import React from 'react';
import { Mail } from 'lucide-react';
import supersetLogo from '../../assets/Superset-Logo.png';
import { useApp } from '../../contexts/AppProvider'

export default function AdHocDataViz() {
  const { t } = useApp()
  return (
    <div className="mx-auto px-6 py-12">
      <div className="max-w-7xl mx-auto space-y-12">

        {/* Header */}
        <div className="flex items-center justify-center gap-6">
          <img 
            src={supersetLogo} 
            alt="Superset Logo"
            className="object-cover"
            style={{ width: 120, height: 100, borderRadius: "30%" }}
          />
          
          <div>
            <h1 
              className="text-3xl font-bold"
              style={{ color: 'var(--color-text)' }}
            >
              {t("adHocViztitle")}
            </h1>
            <p 
              className="text-lg"
              style={{ color: 'var(--color-muted)' }}
            >
              {t("adHocsubtitle")}
            </p>
          </div>
        </div>

        {/* Description */}
        <div className="space-y-4">
          <p
            className="text-base leading-relaxed"
            style={{ color: 'var(--color-text)' }}
          >
            {t("adHocdescription1")}
          </p>

          <p
            className="text-base leading-relaxed font-medium"
            style={{ color: 'var(--color-primary)' }}
          >
            {t("adHocdescription2")}
          </p>
        </div>

        {/* Features List */}
        <div>
          <h2 
            className="text-xl font-semibold mb-4"
            style={{ color: 'var(--color-text)' }}
          >
            {t("adHocfeaturesTitle")}
          </h2>

          <ul className="space-y-2">
            {[
              t('adHocfeature1'),
              t('adHocfeature2'),
              t('adHocfeature3'),
              t('adHocfeature4')
            ].map((feature, index) => (
              <li 
                key={index}
                className="flex items-start gap-2 text-base"
                style={{ color: 'var(--color-text)' }}
              >
                <span style={{ color: 'var(--color-primary)' }}>•</span>
                <span>{feature}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact Section */}
        <div
          className="p-6 rounded-lg"
          style={{
            backgroundColor:
              'color-mix(in srgb, var(--color-primary) 5%, var(--color-background))'
          }}
        >
          <h2 
            className="text-lg font-semibold mb-2"
            style={{ color: 'var(--color-text)' }}
          >
            {t("adHocsetupTitle")}
          </h2>

          <p 
            className="mb-4"
            style={{ color: 'var(--color-muted)' }}
          >
            {t("adHocsetupDescription")}
          </p>

          <button
            className="px-6 py-2 font-medium rounded-md inline-flex items-center gap-2 transition-all duration-200"
            style={{
              backgroundColor: 'var(--color-primary)',
              color: 'white'
            }}
          >
            <Mail className="w-4 h-4" />
            <span>{t("adHoccontactButton")}</span>
          </button>
        </div>
      </div>
    </div>
  );
}
